import { Box, Divider } from "@mui/material";

import AlainAdmin from "./AlainAdmin";
import VersionHistory from "../components/VersionHistory";

export default function JayAdmin() {
  return (
    <>
      <AlainAdmin />

      <Box sx={{ maxWidth: 1400, mx: "auto", px: 3, pb: 4 }}>
        <Divider sx={{ mb: 4 }} />
        <VersionHistory />
      </Box>
    </>
  );
}
